import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full grid grid-cols-7 gap-2 px-2 pt-2 pb-4 bg-white rounded-lg" }
const _hoisted_2 = { class: "font-semibold text-xl text-brown" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "text-brown group-hover:text-white group-active:text-white font-normal text-base leading-[20px] z-10" }

import { computed } from "vue";
import { ChineseCalendarDate } from "@/types/calculators";
import { WEEK_KEYS } from "@/constants/chineseCalendar";
import { useI18n } from "vue-i18n";
import router from "@/router";
import { ROUTE_NAMES } from "@/constants/routeNames";


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileCalendar',
  props: {
    chineseCalendar: {},
    month: {},
    year: {},
    monthKey: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const firstDay = computed(() => {
  const startOfMonth = new Date(props.year, props.month, 1);
  const firstDayIndex = startOfMonth.getDay() - 1;
  // Sunday has 0 index that after -1 gives -1 index
  if (firstDayIndex == -1) {
    return 6;
  }
  return firstDayIndex;
});

function openFullDayInfo(date: string) {
  router.push({
    name: ROUTE_NAMES.CHINESE_CALENDAR_DAY,
    query: { date: date },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(WEEK_KEYS), (weekKey) => {
        return (_openBlock(), _createElementBlock("div", {
          key: weekKey,
          class: "min-h-11 flex items-center justify-center"
        }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)(`week-names.${weekKey}`)), 1)
        ]))
      }), 128)),
      (firstDay.value && firstDay.value !== 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: _normalizeStyle({ gridColumn: firstDay.value === -1 ? 'span 6' : `span ${firstDay.value}` })
          }, null, 4))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.chineseCalendar, (chineseDay, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: chineseDay.date,
          class: "flex items-center justify-center min-h-8 relative group",
          onClick: ($event: any) => (openFullDayInfo(chineseDay.date))
        }, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "h-full aspect-square rounded-full group-hover:bg-active group-active:bg-[#FDB695] absolute opacity-0 group-hover:opacity-100 group-active:opacity-100" }, null, -1)),
          _createElementVNode("span", _hoisted_4, _toDisplayString(index + 1), 1)
        ], 8, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})